import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ENROLL_SOURCE, ENROLL_TYPE } from '../services/googleAnalytics';
import LanguagePrefixContext from '../contextProviders/LanguagePrefixContext';

const WHITE_LIST = [
  /^(\/[a-z]{2})?\/$/i,
  /^(\/[a-z]{2})?\/academy(\/[a-zA-Z0-9-_]+(\/play)?)?\/?$/i,
  /^(\/[a-z]{2})?\/shop$/i,
  /^(\/[a-z]{2})?\/shop\/checkout\$/i,
  /^(\/[a-z]{2})?\/shop\/product\/[a-zA-Z0-9-_]+\/?$/i,
  /^(\/[a-z]{2})?\/certificate\/[a-zA-Z0-9-_]+\/?$/i,
];

function getLink(href) {
  try {
    const link = new URL(href);
    return link.pathname;
  } catch (err) {
    return href;
  }
}

export default function Anchor(props) {
  const {
    children,
    enrollInfo,
    languagePrefix: languagePrefixParam,
    href,
    blockLink,
    target,
    redirectToAnotherDomain,
    ...other
  } = props;

  const languagePrefix =
    languagePrefixParam || useContext(LanguagePrefixContext);
  const linkPrefix = languagePrefix ? `/${languagePrefix}` : '';

  const isButton = !props.href || props.onClick;
  const isWhiteListed =
    !isButton &&
    WHITE_LIST.reduce(
      (hasMatch, regex) => hasMatch || regex.test(getLink(props.href)),
      false,
    );

  const ref = href ? `${redirectToAnotherDomain ? '' : linkPrefix}${href}` : href;
  return (
    <a
      {...other}
      href={ref}
      data-blocked-link={!isWhiteListed || blockLink}
      data-enroll-info={enrollInfo ? JSON.stringify(enrollInfo) : undefined}
      target={target}
    >
      {children}
    </a>
  );
}

Anchor.propTypes = {
  href: PropTypes.string,
  languagePrefix: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.node,
  enrollInfo: PropTypes.shape({
    event: PropTypes.oneOf(Object.values(ENROLL_TYPE)).isRequired,
    name: PropTypes.string.isRequired,
    source: PropTypes.oneOf(Object.values(ENROLL_SOURCE)).isRequired,
    isLogged: PropTypes.bool.isRequired,
  }),
  blockLink: PropTypes.bool,
  redirectToAnotherDomain: PropTypes.bool,
  target: PropTypes.string,
};

Anchor.defaultProps = {
  href: null,
  onClick: null,
  children: null,
  enrollInfo: null,
  languagePrefix: '',
  blockLink: false,
  redirectToAnotherDomain: false,
  target: '_self',
};
